import { AdaBindMethodPipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { FormConfigurationEditorModule, FormRendererComponentModule } from '@adaptiva/forms/widgets';
import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe, SerializedPropertyMapPipe } from '@adaptiva/metadata/common';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { ExpressionLanguageEditorModule } from '@adaptiva/widgets/expression-editor';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { ListBuilderComponentModule } from '@adaptiva/widgets/list-builder';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { TimeScaleComponentModule } from '@adaptiva/widgets/time-scale';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { SensorActionSequenceComponentModule } from '../sensor-action-sequence';
import { InstallPropertiesComponent } from './install-properties.component';
import { RepairPropertiesComponent } from './repair-properties.component';
import { UninstallPropertiesComponent } from './uninstall-properties.component';

const DECLARATIONS: Type<any>[] = [
	InstallPropertiesComponent,
	UninstallPropertiesComponent,
	RepairPropertiesComponent
];

const WIDGETS: Type<any>[] = [
	CardComponentModule,
	TextComponentModule,
	ContainerComponentModule,
	OverlayComponentModule,
	ButtonComponentModule,
	FormRendererComponentModule,
	InputComponentModule,
	ComboComponentModule,
	ExpressionLanguageEditorModule,
	ToggleSwitchComponent,
	SensorActionSequenceComponentModule,
	AuthoringPropertyLabelComponentModule,
	ListBuilderComponentModule,
	TimeScaleComponentModule,
	FormConfigurationEditorModule,
	AdaBindMethodPipe
];

const PIPES: Type<PipeTransform>[] = [
	DisplayAuthoringPropertyPipe,
	InheritPipe,
	IsRequiredPropertyPipe,
	SerializedPropertyMapPipe
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		TemplateMarkerDirectiveModule,
		WIDGETS,
	],
	declarations: DECLARATIONS,
	exports: DECLARATIONS
})
export class FormAuthoringModule {

}
